function r(a) {
  return {
    id: `simple-tab-${a}`,
    "aria-controls": `simple-tabpanel-${a}`
  };
}
export {
  r as a11yProps
};
